export enum BadgeDotSize {
  SMALL = 8,
  LARGE = 16,
}
